import React from 'react';

function Card({ title, subtitle, children, className = '', actions }) {
    return (
        <div className={`card ${className}`.trim()}>
            {(title || subtitle || actions) && (
                <div className="card-header">
                    <div>
                        {title && <h2 className="card-title">{title}</h2>}
                        {subtitle && <span className="text-muted">{subtitle}</span>}
                    </div>
                    {actions && <div className="card-actions">{actions}</div>}
                </div>
            )}
            {children}
        </div>
    );
}

export default Card;
